import {FormInstance} from 'antd/es/form';
import {useForm} from 'antd/es/form/Form';
import React, {forwardRef, useImperativeHandle, useState} from 'react';

import {TStateSetter} from 'shared/types/generics';
import {IAisInterfaceDocumentDto} from 'store/slices/ais-slice/ais-slice-types';

import {EFormMode} from '../../../../../components/form';
import {MainInfo} from './main-info';

interface IDocumentCardModalContentProps {
    initialInterfaceDocument?: IAisInterfaceDocumentDto;
    formMode: EFormMode;
    isDisabled?: boolean;
}

export interface IDocumentCardModalContentRef {
    form: FormInstance;
    interfaceDocument: IAisInterfaceDocumentDto | undefined;
    setInterfaceDocument: TStateSetter<IAisInterfaceDocumentDto | undefined>;
}

export const DocumentCardModalContent = forwardRef<
    IDocumentCardModalContentRef,
    IDocumentCardModalContentProps>((props: IDocumentCardModalContentProps, ref) => {
        const {
            initialInterfaceDocument,
            formMode,
            isDisabled,
        } = props;

        const [form] = useForm();
        const [interfaceDocument, setInterfaceDocument] = useState<IAisInterfaceDocumentDto | undefined>(
            initialInterfaceDocument,
        );

        useImperativeHandle(ref, () => ({
            form,
            interfaceDocument,
            setInterfaceDocument,
        }));

        return (
            <MainInfo
                interfaceDocument={interfaceDocument}
                form={form}
                formMode={formMode}
                isDisabled={isDisabled}
            />
        );
    });
